<template>
  <div class="generate-endpoint-connector">
    <h1>终端连接生成器</h1>
    <div class="generate-form">
      <el-form
        :model="generateForm"
        label-width="auto"
        :inline="true"
        :rules="generateRule"
      >
        <el-form-item label="创建数量" prop="number">
          <el-input v-model="generateForm.number"></el-input>
        </el-form-item>
        <el-form-item label="终端名称前缀" prop="number">
          <el-input v-model="generateForm.namePrefix"></el-input>
        </el-form-item>
        <el-form-item label="终端类型前缀" prop="number">
          <el-input v-model="generateForm.typePrefix"></el-input>
        </el-form-item>
        <el-form-item label="一次性生成码" prop="oneTimeCode">
          <el-input v-model="generateForm.oneTimeCode"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="success"
            :loading="btnSubmitGenerateLoading"
            @click="submitGenerate"
          >
            生成
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <p v-if="connectors.length > 0" class="connectors-warning">
      注意：以下三元组仅显示一次，刷新或退出页面后将无法再次查看连接密码，请注意保存！
      <el-button type="primary" @click="exportExcel">导出</el-button>
    </p>
    <div class="connector-table">
      <el-table v-if="connectors.length > 0" :data="connectors" height="100%">
        <el-table-column prop="name" label="终端名称" />
        <el-table-column prop="id" label="Client ID" />
        <el-table-column prop="username" label="username" />
        <el-table-column prop="password_hash" label="password" />
      </el-table>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { FormRules } from "element-plus/es/components/form/src/types";
import { reactive, ref } from "vue";
import { generateEndpointsApi } from "../../api/endpoint/endpointApi";
import { ElMessage } from "element-plus";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const generateForm = reactive({
  number: null,
  namePrefix: "",
  typePrefix: "",
  oneTimeCode: "",
});
const generateRule = reactive<FormRules>({
  number: [
    { required: true, message: "数量不得为空", trigger: "blur" },
    { min: 1, max: 100, message: "数量范围1-100", trigger: "blur" },
  ],
});

const btnSubmitGenerateLoading = ref<boolean>(false);
const connectors = ref<any>([]);
const submitGenerate = async () => {
  if (generateForm.number === null) return;
  btnSubmitGenerateLoading.value = true;
  const response = await generateEndpointsApi(
    generateForm.number,
    generateForm.namePrefix,
    generateForm.typePrefix,
    generateForm.oneTimeCode
  );
  btnSubmitGenerateLoading.value = false;
  console.log(response);
  if (response) {
    generateForm.oneTimeCode = "";
    generateForm.number = null;
    connectors.value = response;
    ElMessage.success("生成成功");
  } else {
    ElMessage.error("生成失败");
  }
};

const exportExcel = () => {
  if (connectors.value <= 0) return;
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("终端三元组");
  worksheet.columns = [
    { header: "终端名称", key: "name", width: 30 },
    { header: "Client ID", key: "id", width: 20 },
    { header: "username", key: "username", width: 25 },
    { header: "password", key: "password_hash", width: 30 },
  ];
  connectors.value.forEach((connector: any) => {
    worksheet.addRow(connector);
  });
  const today = new Date();
  const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, "");
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `终端三元组-${formattedDate}.xlsx`); // 文件名带上当前日期
  });
};
</script>
<style scoped lang="less">
.generate-endpoint-connector {
  padding: 7px;
}
.generate-form {
  height: 50px;
  width: 100%;
}
.connectors-warning {
  height: 40px;
  text-align: 40px;
  padding-left: 20px;
  color: red;
}
.connector-table {
  width: 100%;
  height: calc(100% - 150px);
}
</style>
